import React, { useState, useEffect, useRef, useContext } from "react";
import {
  Button,
  Card,
  ConfigProvider,
  Descriptions,
  Divider,
  PageHeader,
  Table,
  Typography,
} from "antd";
import _ from "lodash";
import moment from "moment";
// import { ImageViewer } from "react-image-viewer-dv";
import { Tabs } from "antd";
import { useReactToPrint } from "react-to-print";
import {
  CheckCircleFilled,
  DownloadOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { LanguageContext } from "../../../context/LanguageContext";
import { ImageViewOnly } from "../../image/onlyImageVIew";
import { professionalAction } from "../../../_actions";
import { connect } from "react-redux";
import domtoimage from "dom-to-image-more";
const { Text } = Typography;

const ViewFormModel = (props) => {
  console.log("prevetive report");
  document.querySelectorAll(".tab-pane").forEach(function (tab) {
    tab.style.display = "block";
  });
  useEffect(() => {
    props.dispatch(professionalAction.getAllMaster());
    props.dispatch(professionalAction.getCity());
  }, []);
  const { TabPane } = Tabs;
  const contentToPrint = useRef(null);
  const personalInfoRef = useRef(null);
  const crimeInfoRef = useRef(null);
  const socialInfoRef = useRef(null);
  const arrestInfoRef = useRef(null);
  const noticeInfoRef = useRef(null);
  const preventiveInfoRef = useRef(null);
  const courtInfoRef = useRef(null);
  const ncrInfoRef = useRef(null);
  const documenInfoRef = useRef(null);
  const { t } = useContext(LanguageContext);
  const [id, setId] = useState(null);
  const [basicInfo, setbasicInfor] = useState([]);
  const [otherInfo, setOtherInfo] = useState([]);
  const [gunhaInfo, setGunhaInfo] = useState([]);
  const [arrestInfo, setArrestInfo] = useState([]);
  const [noticeInfo, setNoticeInfo] = useState([]);
  const [preventiveInfo, setPreventiveInfo] = useState([]);
  const [imageOpen, setImageOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [wantedHistory, setWantedHistory] = useState();
  const [ncrInfo, setNcrInfo] = useState([]);
  const openImageModal = (img, id) => {
    setImageOpen(true);
    setSelectedImage(img);
    setId(id);
  };

  const closeImageModal = () => {
    setImageOpen(false);
    setSelectedImage(null);
  };

  const downloadFullPreview = async () => {
    const node = document.getElementById("view-profile");
    const printIdEl = document.getElementById("print");
    const scrollId = document.getElementById("scroll-up");
    const crimeTab = document.getElementById("crime_tab");

    // hide elements
    if (printIdEl) printIdEl.style.display = "none";
    if (scrollId) scrollId.style.display = "none";
    if (crimeTab) crimeTab.style.display = "none";

    // store original styles
    const originalOverflow = node.style.overflow;
    const originalPosition = node.style.position;

    // fix scroll + layout issues
    node.style.overflow = "visible";
    node.style.position = "relative";

    // 👉 Create footer
    const footer = document.createElement("div");
    footer.id = "temp-footer";
    footer.innerText = `Generated At ${moment().format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    footer.style.width = "100%";
    footer.style.textAlign = "center";
    footer.style.marginTop = "20px";
    footer.style.fontWeight = "bold"; // ✅ bold text
    footer.style.fontSize = "14px";
    footer.style.padding = "10px 0";

    // append footer
    node.appendChild(footer);

    try {
      const blob = await domtoimage.toBlob(node, {
        bgcolor: "#ffffff",
        cacheBust: true,
        width: node.scrollWidth,
        height: node.scrollHeight,
        style: {
          transform: "scale(1)",
          transformOrigin: "top left",
        },
      });

      const url = URL.createObjectURL(blob);

      const name1 = `CMIS_${basicInfo[0]?.id}_${basicInfo[0]?.name}`;
      const link = document.createElement("a");
      link.href = url;
      link.download = name1 ? `${name1}.png` : "CMIS_Record.png";
      link.click();

      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed:", err);
    }

    // 👉 remove footer after download
    const addedFooter = document.getElementById("temp-footer");
    if (addedFooter) addedFooter.remove();

    // cleanup
    node.style.overflow = originalOverflow;
    node.style.position = originalPosition;

    // show elements again
    if (printIdEl) printIdEl.style.display = "flex";
    if (scrollId) scrollId.style.display = "";
    if (crimeTab) crimeTab.style.display = "";
  };
  const {
    pc_cities,
    pc_status,
    pc_crimetitles,
    pc_crimetypes,
    pc_countrystates,
  } = props.dataStates;

  function parseDateAnyFormat(dateStr) {
    dateStr = dateStr ? dateStr.trim() : "";
    let dateObj = new Date(dateStr);
    if (!isNaN(dateObj)) return dateObj;
    dateStr = dateStr.replace(/[-.]/g, "/");
    const parts = dateStr.split(/[/\s,:]+/);
    if (parts.length === 3) {
      if (parts[0].length === 4) {
        if (parseInt(parts[1]) > 12) {
          dateObj = new Date(`${parts[0]}/${parts[2]}/${parts[1]}`); // YYYY/DD/MM
        } else {
          dateObj = new Date(`${parts[0]}/${parts[1]}/${parts[2]}`); // YYYY/MM/DD
        }
      } else if (parts[2].length === 4) {
        dateObj = new Date(`${parts[2]}/${parts[1]}/${parts[0]}`);
      }
    } else if (parts.length === 6) {
      if (parts[0].length === 4) {
        dateObj = new Date(
          `${parts[0]}/${parts[1]}/${parts[2]} ${parts[3]}:${parts[4]}:${parts[5]}`,
        );
      } else {
        dateObj = new Date(
          `${parts[2]}/${parts[1]}/${parts[0]} ${parts[3]}:${parts[4]}:${parts[5]}`,
        );
      }
    }
    return !isNaN(dateObj) ? dateObj : "Invalid Date";
  }

  useEffect(
    (res) => {
      const { criminalPlusList } = props.dataStates;
      if (
        criminalPlusList &&
        criminalPlusList.basicInfo &&
        criminalPlusList.basicInfo
      ) {
        let tempbasic = {
          ...criminalPlusList.basicInfo[0],
          heading: JSON.parse(
            "[" + criminalPlusList.basicInfo[0].heading + "]",
          ),
        };
        setbasicInfor([tempbasic]);
      }
      if (
        criminalPlusList &&
        criminalPlusList?.wantedHistory &&
        criminalPlusList?.wantedHistory
      ) {
        let tempwanted = {
          ...criminalPlusList?.wantedHistory[0],
          historydate: criminalPlusList?.wantedHistory[0]?.history_date
            ? moment(criminalPlusList?.wantedHistory[0]?.history_date).format(
                "DD/MM/YYYY",
              )
            : null,
        };
        setWantedHistory(tempwanted);
      }
      if (
        criminalPlusList &&
        criminalPlusList.gunhaInfor &&
        criminalPlusList.gunhaInfor
      ) {
        let temp =
          criminalPlusList.gunhaInfor &&
          criminalPlusList.gunhaInfor.map((item) => {
            let dateobj = parseDateAnyFormat(item.dateTime);
            return {
              ...item,
              statusDate: item.statusDate
                ? moment(item.statusDate).format("DD/MM/YYYY")
                : null,
              registernumberYear: item.registernumberYear
                ? moment(item.registernumberYear).format("YYYY")
                : null,
              // dateTime: item.dateTime ? moment(item.dateTime, "DD/MM/YYYY").format("DD/MM/YYYY") : null
              // dateTime: moment(dateobj).format("DD/MM/YYYY"),
            };
          });

        const sortedGunhaInfo = [...temp].sort((a, b) => {
          const dateA = parseDateAnyFormat(a.dateTime);
          const dateB = parseDateAnyFormat(b.dateTime);
          const timeA =
            dateA === "Invalid Date" ? 0 : new Date(dateA).getTime();
          const timeB =
            dateB === "Invalid Date" ? 0 : new Date(dateB).getTime();
          return timeB - timeA;
        });

        setGunhaInfo(sortedGunhaInfo);
      }
      if (
        criminalPlusList &&
        criminalPlusList.gunhaInfor &&
        criminalPlusList.gunhaInfor
      ) {
        let temp =
          criminalPlusList.gunhaInfor &&
          criminalPlusList.gunhaInfor.map((item) => {
            const arrestInfo = item?.arrestInfo || [];
            const noticeInfo = item?.noticeInfo || [];
            const lastElement = arrestInfo[0];
            if (lastElement && lastElement?.photo) {
              lastElement.photos = lastElement?.photo
                ?.split(",")
                .map((photo) => photo.trim());
            }
            return {
              ...item,
              arrestInfo: [...arrestInfo],
              noticeInfo: [...noticeInfo],
            };
          });
        setArrestInfo([...temp]);
        setNoticeInfo([...temp]);
      }
      if (
        criminalPlusList &&
        criminalPlusList.otherInfo &&
        criminalPlusList.otherInfo
      ) {
        setOtherInfo([...criminalPlusList.otherInfo]);
      }
      if (
        criminalPlusList &&
        criminalPlusList.preventiveInfo &&
        criminalPlusList.preventiveInfo
      ) {
        const currentDate = moment();

        const updatedPreventiveInfo = criminalPlusList.preventiveInfo.map(
          (ginfo) => {
            const dateTo = ginfo.date_to ? moment(ginfo.date_to) : null;
            const status = dateTo
              ? dateTo.isBefore(currentDate, "day")
                ? "completed"
                : "ongoing"
              : "-";

            // return each item with new 'status' field
            return {
              ...ginfo,
              status,
            };
          },
        );

        setPreventiveInfo(updatedPreventiveInfo);
      }
      if (
        criminalPlusList &&
        criminalPlusList.ncrInfo &&
        criminalPlusList.ncrInfo
      ) {
        setNcrInfo(criminalPlusList.ncrInfo);
      }
    },
    [props.dataStates],
  );
  // STATE
  const getStateName = (id) => {
    if (pc_countrystates && pc_countrystates.length) {
      return (
        _.filter(pc_countrystates, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_countrystates, function (o) {
          return o.id === id;
        })[0].state
      );
    }
  };

  // CITY
  const getCityName = (id) => {
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  const getCrimetypes = (id) => {
    if (pc_crimetypes && pc_crimetypes.length) {
      return (
        _.filter(pc_crimetypes, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_crimetypes, function (o) {
          return o.id === id;
        })[0].crimetype
      );
    }
  };
  const getCrimeTitle = (id) => {
    if (pc_crimetitles && pc_crimetitles.length) {
      return (
        _.filter(pc_crimetitles, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_crimetitles, function (o) {
          return o.id === id;
        })[0].crime_title
      );
    }
  };
  const getStatus = (id) => {
    if (pc_status && pc_status.length) {
      return (
        _.filter(pc_status, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_status, function (o) {
          return o.id === id;
        })[0].name
      );
    }
  };
  const [preventiveAction, setPreventiveAction] = useState([]);
  const getPreventiveData = () => {
    professionalAction.getPreventiveAction().then((res) => {
      res &&
        res.text().then((preventiveList) => {
          const data = [];
          preventiveList &&
            JSON.parse(preventiveList).data.forEach((item) => {
              data.push(item);
            });
          setPreventiveAction(data);
        });
    });
  };

  useEffect(() => {
    getPreventiveData();
  }, []);

  const getPreventiveName = (id) => {
    console.log("id", id);
    console.log("props", props);
    if (preventiveAction && preventiveAction?.length > 0) {
      return (
        _.filter(preventiveAction, function (o) {
          return o.id === Number(id);
        })[0] &&
        _.filter(preventiveAction, function (o) {
          return o.id === Number(id);
        })[0].name
      );
    }
  };

  const handlePrint = useReactToPrint({
    documentTitle: `${otherInfo[otherInfo.length - 1]?.masterId}_${
      basicInfo[0]?.name
    }`,
    removeAfterPrint: true,
    pageStyle: `
    @media print {
      #scroll-up {
        display: none !important;
        visibility: hidden !important;
      }
    }
  `,
  });

  useEffect(() => {
    if (id) {
      handlePrint();
    }
  }, [id]);

  const handleTabChange = (key) => {
    if (key === "1" && personalInfoRef.current) {
      personalInfoRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (key === "2" && crimeInfoRef.current) {
      crimeInfoRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (key === "3" && socialInfoRef.current) {
      socialInfoRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (key === "4" && arrestInfoRef.current) {
      arrestInfoRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (key === "5" && noticeInfoRef.current) {
      noticeInfoRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (key === "6" && preventiveInfoRef.current) {
      preventiveInfoRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (key === "7" && courtInfoRef.current) {
      courtInfoRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (key === "8" && ncrInfoRef.current) {
      ncrInfoRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (key === "9" && documenInfoRef.current) {
      documenInfoRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToTop = () => {
    contentToPrint.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
        <Button
          style={{
            background: "#6f42c1",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
          type="primary"
          icon={<DownloadOutlined />}
          onClick={downloadFullPreview}
          title="Download JPG"
        >
          JPG
        </Button>

        <Button
          id="print"
          type="primary"
          icon={<DownloadOutlined />}
          style={{
            background: "#28a745",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
          onClick={() => handlePrint(null, () => contentToPrint.current)}
          title="Download PDF"
        >
          PDF
        </Button>
      </div>
      <div ref={contentToPrint} id="view-profile">
        <PageHeader
          ghost={false}
          onBack={false}
          subTitle={
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "2px",
                color: "black",
              }}
            >
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                }}
              >
                <span
                  style={{
                    color: "#022182d9",
                  }}
                >
                  CMIS Id:{" "}
                </span>
                {basicInfo && basicInfo[0]?.id}
              </p>
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                }}
              >
                <span
                  style={{
                    color: "#022182d9",
                  }}
                >
                  {t("name_of_the_accused")}:
                </span>
                {basicInfo && basicInfo[0]?.name}
                {props.dataStates?.criminalViewList
                  ?.document_complete_verified === true && (
                  <CheckCircleFilled
                    title="Verified document"
                    style={{
                      fontSize: "16px",
                      color: "#52c41a",
                      cursor: "pointer",
                      marginLeft: "10px",
                      flexShrink: 0,
                    }}
                  />
                )}
              </p>
            </div>
          }
          extra={[
            <span style={{ display: "flex" }}>
              {otherInfo && otherInfo.length
                ? otherInfo[otherInfo.length - 1].accusedImage &&
                  otherInfo[otherInfo.length - 1].accusedImage.length &&
                  otherInfo[otherInfo.length - 1].accusedImage
                    .split(",")
                    .map((item) => (
                      <Card
                        className="viewCard"
                        // hoverable
                        style={{
                          width: "100px",
                          height: "100px",
                          margin: "0px 15px 20px 0px",
                          borderRadius: "50%",
                          display: "flex",
                        }}
                        cover={
                          // <ImageViewer>
                          <img
                            alt="example"
                            src={
                              "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                              item
                            }
                            style={{
                              width: 100,
                              height: 100,
                              borderRadius: "50%",
                            }}
                            onClick={() =>
                              openImageModal(
                                item,
                                basicInfo && basicInfo[0]?.id,
                              )
                            }
                          />
                          // </ImageViewer>
                        }
                      ></Card>
                    ))
                : null}
            </span>,
          ]}
        ></PageHeader>

        <ConfigProvider
          getPopupContainer={
            (triggerNode) =>
              triggerNode.closest(".ant-modal-content") || document.body // Fallback to body if not in modal
          }
        >
          <div
            style={{
              width: "100%",
              maxWidth: "100%",
              overflow: "visible", // Allows overflow detection for "more" button
              position: "relative",
            }}
          >
            <Tabs
              id="crime_tab"
              defaultActiveKey="1"
              onChange={handleTabChange}
              tabBarGutter={20}
              style={{ width: "100%" }}
              tabBarStyle={{
                overflow: "visible", // Ensures dropdown can pop out
              }}
            >
              <TabPane tab={t("personal_information")} key="1" />
              <TabPane tab={t("crime_information")} key="2" />
              <TabPane tab={t("crNumber")} key="8" />
              <TabPane tab={t("preventive_action")} key="6" />
              <TabPane tab={t("arrest_history")} key="4" />
              <TabPane tab={t("notice")} key="5" />
              <TabPane tab={t("social_information")} key="3" />
              <TabPane tab={t("court_cases")} key="7" />
              <TabPane tab="आरोपीचे ओळखपत्र" key="9" />
            </Tabs>
          </div>
        </ConfigProvider>
        <div ref={personalInfoRef}>
          <PageHeader
            ghost={false}
            onBack={false}
            title={t("personal_information")}
          >
            {basicInfo && basicInfo.length ? (
              <Card className="viewCard profile-desc">
                <Descriptions
                  size="small"
                  column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                >
                  <Descriptions.Item label={t("name_of_the_accused")}>
                    {basicInfo && basicInfo[0].name}
                  </Descriptions.Item>

                  <Descriptions.Item label={t("title")}>
                    {/* {basicInfo &&
                    basicInfo[0]?.heading?.map((res, i) => (
                      <span key={i}>
                        {getCrimetypes(res)}
                        {i !== basicInfo[0].heading.length - 1 && ", "}
                      </span>
                    ))} */}
                    {basicInfo &&
                      basicInfo[0]?.headingNames?.map((res, i) => (
                        <span key={i}>
                          {res}
                          {i !== basicInfo[0].headingNames.length - 1 && ", "}
                        </span>
                      ))}
                  </Descriptions.Item>

                  <Descriptions.Item label={t("history_sheeter")}>
                    {wantedHistory?.historySheeter === 1 ||
                    wantedHistory?.historySheeter === 3
                      ? t("yes")
                      : t("no")}
                  </Descriptions.Item>

                  {(wantedHistory?.historySheeter === 1 ||
                    wantedHistory?.historySheeter === 3) && (
                    <Descriptions.Item label={t("history_sheeter_entry_date")}>
                      {wantedHistory?.historydate}
                    </Descriptions.Item>
                  )}

                  <Descriptions.Item label={t("accused_age")}>
                    {basicInfo && basicInfo[0].age}
                  </Descriptions.Item>

                  <Descriptions.Item label={t("mobile_number")}>
                    {basicInfo && basicInfo[0].mobileNumber}
                  </Descriptions.Item>

                  <Descriptions.Item label={t("state")}>
                    {getStateName(basicInfo && basicInfo[0].state)}
                  </Descriptions.Item>

                  <Descriptions.Item label={t("unit")}>
                    {getCityName(basicInfo && basicInfo[0].city)}
                  </Descriptions.Item>

                  <Descriptions.Item label={t("police_station")}>
                    {basicInfo && basicInfo[0].districtName}
                  </Descriptions.Item>

                  {wantedHistory?.current_condition && (
                    <Descriptions.Item label={t("current_status")}>
                      {wantedHistory?.current_condition}
                    </Descriptions.Item>
                  )}

                  <Descriptions.Item label={t("address")}>
                    {basicInfo && basicInfo[0].address}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            ) : null}
          </PageHeader>
        </div>
        {/* <div ref={crimeInfoRef}>
        <PageHeader ghost={false} onBack={false} title={t("crime")}>
          {gunhaInfo &&
            gunhaInfo.length &&
            gunhaInfo.map((ginfo, index) => (
              <>
                <Divider orientation="left" style={{ margin: "10px 0px" }}>
                  {t("crime") + " - "}
                  {index + 1}
                </Divider>
                <Card className="viewCard profile-desc">
                  <Descriptions
                    size="small"
                    column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                  >
                   
                    <Descriptions.Item
                      size="small"
                      column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                      label={
                        <span className="sub-heading">
                          {t("crime_police_station")}
                        </span>
                      }
                    >
                      {`${ginfo.districtName} (${getCityName(
                        ginfo.city
                      )}, ${getStateName(ginfo.state)})`}
                    </Descriptions.Item>
                    <Descriptions.Item
                      size="small"
                      column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                      label={
                        <span className="sub-heading">
                          {t("crime_register_number")}
                        </span>
                      }
                    >
                      {`${ginfo.registernumber}/${ginfo.registernumberYear}`}
                    </Descriptions.Item>                   
                    <Descriptions.Item
                      size="small"
                      column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                      label={
                        <span className="sub-heading">
                          {t("crime_registration_date")}
                        </span>
                      }
                    >
                      {ginfo?.dateTime
                        ? moment(ginfo?.dateTime).format("DD/MM/YYYY")
                        : ""}
                    </Descriptions.Item>
                    <Descriptions.Item
                      size="small"
                      column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                      label={<span className="sub-heading">{t("title")}</span>}
                    >
                      {getCrimeTitle(ginfo.heading)}
                    </Descriptions.Item>
                    <Descriptions.Item
                      size="small"
                      column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                      label={
                        <span className="sub-heading">
                          {t("current_status")}
                        </span>
                      }
                    >
                      {getStatus(ginfo.status)}
                    </Descriptions.Item>

                    {(ginfo && ginfo.status && ginfo.status === 2) ||
                    (ginfo && ginfo.status && ginfo.status === 3) ? (
                      <>
                        <Descriptions.Item
                          size="small"
                          column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                          label={
                            <span className="sub-heading">
                              {t("types_of_court")}
                            </span>
                          }
                        >
                          {ginfo.typesOfCourt}
                        </Descriptions.Item>
                        <Descriptions.Item
                          size="small"
                          column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                          label={
                            <span className="sub-heading">
                              {t("status_date")}
                            </span>
                          }
                        >
                          {ginfo.statusDate}
                        </Descriptions.Item>
                        <Descriptions.Item
                          size="small"
                          column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                          label={
                            <span className="sub-heading">
                              {t("case_number")}
                            </span>
                          }
                        >
                          {ginfo.caseNumbers}
                        </Descriptions.Item>
                      </>
                    ) : null}

                    {ginfo && ginfo.status && ginfo.status === 3 ? (
                      <>
                        <Descriptions.Item
                          size="small"
                          column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                          label={
                            <span className="sub-heading">
                              {t("punishment")}
                            </span>
                          }
                        >
                          {ginfo.punishment}
                        </Descriptions.Item>
                        <Descriptions.Item
                          size="small"
                          column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                          label={
                            <span className="sub-heading">{t("penalty")}</span>
                          }
                        >
                          {ginfo.Penalty}
                        </Descriptions.Item>
                      </>
                    ) : null}
                  </Descriptions>
                </Card>

                <Divider style={{ margin: "10px 0px" }} orientation="left">
                  {t("law")} - {t("section")}
                </Divider>
                <Card className="viewCard profile-desc">
                  <Descriptions
                    size="small"
                    column={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}
                  >
                    {ginfo &&
                      ginfo.kalamAndkayda.map((res) => (
                        <>
                          <Descriptions.Item
                            label={
                              <span className="sub-heading">{t("law")}</span>
                            }
                          >
                            {res.rulesName}
                          </Descriptions.Item>
                          <Descriptions.Item
                            label={
                              <span className="sub-heading">
                                {t("section")}
                              </span>
                            }
                          >
                            {res.kalam}
                          </Descriptions.Item>
                        </>
                      ))}
                  </Descriptions>
                </Card>
                
              </>
            ))}
        </PageHeader>
      </div> */}
        <div ref={crimeInfoRef}>
          <PageHeader ghost={false} onBack={false} title={t("crime")}>
            <table
              className="ant-table ant-table-bordered"
              style={{ border: "1px solid rgb(26, 20, 20)", width: "100%" }}
            >
              <thead className="ant-table-thead">
                <tr>
                  <th
                    className="ant-table-cell"
                    style={{ border: "1px solid rgb(26, 20, 20)" }}
                  >
                    {t("crime")}
                  </th>
                  <th
                    className="ant-table-cell"
                    style={{ border: "1px solid rgb(26, 20, 20)" }}
                  >
                    {t("title")}
                  </th>
                  <th
                    className="ant-table-cell"
                    style={{ border: "1px solid rgb(26, 20, 20)" }}
                  >
                    {t("crime_police_station")}
                  </th>
                  <th
                    className="ant-table-cell"
                    style={{ border: "1px solid rgb(26, 20, 20)" }}
                  >
                    {t("crime_register_number")}
                  </th>
                  <th
                    className="ant-table-cell"
                    style={{ border: "1px solid rgb(26, 20, 20)" }}
                  >
                    {t("crime_registration_date")}
                  </th>
                  <th
                    className="ant-table-cell"
                    style={{ border: "1px solid rgb(26, 20, 20)" }}
                  >
                    {t("law") + " - " + t("section")}
                  </th>
                  <th
                    className="ant-table-cell"
                    style={{ border: "1px solid rgb(26, 20, 20)" }}
                  >
                    {t("current_status")}
                  </th>
                </tr>
              </thead>
              <tbody className="ant-table-tbody">
                {gunhaInfo.map((ginfo, index) => {
                  let lawSection = [];
                  if (
                    Array.isArray(ginfo.kalamAndkayda) &&
                    ginfo.kalamAndkayda.length > 0
                  ) {
                    lawSection = Object.entries(
                      ginfo.kalamAndkayda.reduce((acc, curr) => {
                        if (!acc[curr.rulesName]) {
                          acc[curr.rulesName] = [];
                        }
                        acc[curr.rulesName].push(curr.kalam);
                        return acc;
                      }, {}),
                    ).map(([rulesName, kalams], i) => (
                      <div key={i}>
                        {rulesName}- {kalams.join(", ")}
                      </div>
                    ));
                  }
                  return (
                    <tr key={index}>
                      <td
                        className="ant-table-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {index + 1}
                      </td>
                      <td
                        className="ant-table-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {getCrimeTitle(ginfo.heading)}
                      </td>
                      <td
                        className="ant-table-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {ginfo?.districtName}
                      </td>
                      <td
                        className="ant-table-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {ginfo.registernumber}
                      </td>
                      <td
                        className="ant-table-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {(() => {
                          const parsed = parseDateAnyFormat(ginfo?.dateTime);
                          if (parsed === "Invalid Date") return "-";
                          return parsed.toLocaleDateString("en-GB");
                        })()}
                      </td>
                      <td
                        className="ant-table-cell law-section-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {lawSection.length > 0 ? lawSection : "-"}
                      </td>
                      <td
                        className="ant-table-cell law-section-cell"
                        style={{ border: "1px solid rgb(26, 20, 20)" }}
                      >
                        {getStatus(ginfo.status)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </PageHeader>
        </div>
        <div ref={ncrInfoRef}>
          <PageHeader ghost={false} onBack={false} title={t("crNumber")}>
            {ncrInfo && ncrInfo.length > 0 && (
              <table
                className="ant-table ant-table-bordered"
                style={{ border: "1px solid rgb(26, 20, 20)", width: "100%" }}
              >
                <thead className="ant-table-thead">
                  <tr>
                    <th
                      className="ant-table-cell"
                      style={{ border: "1px solid rgb(26, 20, 20)" }}
                    >
                      {t("crime")}
                    </th>
                    <th
                      className="ant-table-cell"
                      style={{ border: "1px solid rgb(26, 20, 20)" }}
                    >
                      {t("ncr_number")}
                    </th>
                    <th
                      className="ant-table-cell"
                      style={{ border: "1px solid rgb(26, 20, 20)" }}
                    >
                      {t("title")}
                    </th>
                    <th
                      className="ant-table-cell"
                      style={{ border: "1px solid rgb(26, 20, 20)" }}
                    >
                      {t("incident_type")}
                    </th>
                    <th
                      className="ant-table-cell"
                      style={{ border: "1px solid rgb(26, 20, 20)" }}
                    >
                      {t("action_taken_police_station")}
                    </th>
                    <th
                      className="ant-table-cell"
                      style={{ border: "1px solid rgb(26, 20, 20)" }}
                    >
                      {t("incident_datetime")}
                    </th>
                    <th
                      className="ant-table-cell"
                      style={{ border: "1px solid rgb(26, 20, 20)" }}
                    >
                      {t("information_recorded_datetime")}
                    </th>
                    <th
                      className="ant-table-cell"
                      style={{ border: "1px solid rgb(26, 20, 20)" }}
                    >
                      {t("law")} - {t("section")}
                    </th>
                    <th
                      className="ant-table-cell"
                      style={{ border: "1px solid rgb(26, 20, 20)" }}
                    >
                      {t("officer_information")}
                    </th>
                    <th
                      className="ant-table-cell"
                      style={{ border: "1px solid rgb(26, 20, 20)" }}
                    >
                      {t("phone_no")}
                    </th>
                    <th
                      className="ant-table-cell"
                      style={{ border: "1px solid rgb(26, 20, 20)" }}
                    >
                      {t("action_taken")}
                    </th>
                  </tr>
                </thead>

                <tbody className="ant-table-tbody">
                  {ncrInfo.map((ninfo, index) => {
                    /* Group law & section */
                    let lawSection = [];
                    if (
                      Array.isArray(ninfo.kalamAndkayda) &&
                      ninfo.kalamAndkayda.length
                    ) {
                      lawSection = Object.entries(
                        ninfo.kalamAndkayda.reduce((acc, curr) => {
                          if (!acc[curr.rulesName]) acc[curr.rulesName] = [];
                          acc[curr.rulesName].push(curr.kalam);
                          return acc;
                        }, {}),
                      ).map(([rulesName, kalams], i) => (
                        <div key={i}>
                          {rulesName} - {kalams.join(", ")}
                        </div>
                      ));
                    }

                    return (
                      <tr key={index}>
                        <td
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {index + 1}
                        </td>

                        <td
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {ninfo?.ncr_registernumber || "-"}
                        </td>

                        <td
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {ninfo.headingName || "-"}
                        </td>

                        <td
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {Array.isArray(ninfo.sub_heading_name)
                            ? ninfo.sub_heading_name.join(", ")
                            : "-"}
                        </td>

                        <td
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {ninfo.action_taken_police_station || "-"}
                        </td>

                        <td
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {ninfo?.occurrence_datetime
                            ? moment(ninfo.occurrence_datetime)
                                .local()
                                .format("YYYY-MM-DD hh:mm A")
                            : "-"}
                        </td>

                        <td
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {ninfo?.recorded_datetime
                            ? moment(ninfo.recorded_datetime)
                                .local()
                                .format("YYYY-MM-DD hh:mm A")
                            : "-"}
                        </td>

                        <td
                          className="ant-table-cell law-section-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {lawSection.length > 0 ? lawSection : "-"}
                        </td>

                        <td
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {ninfo.officer_name || "-"}
                        </td>

                        <td
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {ninfo.officer_mobile_no || "-"}
                        </td>

                        <td
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {ninfo.actions_taken || "-"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </PageHeader>
        </div>
        <div ref={preventiveInfoRef}>
          <PageHeader
            ghost={false}
            onBack={false}
            title={t("preventive_action")}
          >
            {preventiveInfo &&
              preventiveInfo.length > 0 &&
              preventiveInfo.map((ginfo, index) => (
                <>
                  <Divider orientation="left" style={{ margin: "10px 0px" }}>
                    {t("preventive_action") + " - "}
                    {index + 1}
                  </Divider>
                  <Card className="viewCard profile-desc">
                    <Descriptions
                      size="small"
                      column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                    >
                      <Descriptions.Item
                        label={
                          <span className="sub-heading">
                            {t("preventive_action")}
                          </span>
                        }
                      >
                        {ginfo.preventive_action
                          ? getPreventiveName(ginfo && ginfo.preventive_action)
                          : ""}
                      </Descriptions.Item>
                      <Descriptions.Item
                        label={
                          <span className="sub-heading">
                            {t("chapter_case_number")}
                          </span>
                        }
                      >
                        {ginfo.chaptorCase}
                      </Descriptions.Item>
                      {ginfo && (
                        <Descriptions.Item
                          label={
                            <span className="sub-heading">
                              {t("action_taken_police_station")}
                            </span>
                          }
                        >
                          {ginfo.action_taken_police_station
                            ? ginfo.action_taken_police_station
                            : "-"}
                        </Descriptions.Item>
                      )}
                      <Descriptions.Item
                        label={
                          <span className="sub-heading">
                            {t("period_from")}
                          </span>
                        }
                      >
                        {ginfo.date_from
                          ? moment(
                              parseDateAnyFormat(ginfo.date_from),
                            ).isValid() &&
                            moment(parseDateAnyFormat(ginfo.date_from)).format(
                              "DD/MM/YYYY",
                            )
                          : ""}
                      </Descriptions.Item>
                      <Descriptions.Item
                        label={
                          <span className="sub-heading">{t("period_to")}</span>
                        }
                      >
                        {ginfo.date_to
                          ? moment(
                              parseDateAnyFormat(ginfo.date_to),
                            ).isValid() &&
                            moment(parseDateAnyFormat(ginfo.date_to)).format(
                              "DD/MM/YYYY",
                            )
                          : ""}
                      </Descriptions.Item>
                      {ginfo.tadipar_unit && (
                        <Descriptions.Item
                          label={
                            <span className="sub-heading">
                              {t("area_of_tadipar")}
                            </span>
                          }
                        >
                          {ginfo.tadipar_unit}
                        </Descriptions.Item>
                      )}
                      {(ginfo && ginfo.status && ginfo.status === 2) ||
                      (ginfo && ginfo.status && ginfo.status === 3) ? (
                        <>
                          <Descriptions.Item
                            label={
                              <span className="sub-heading">
                                {t("types_of_court")}
                              </span>
                            }
                          >
                            {ginfo.typesOfCourt}
                          </Descriptions.Item>
                          <Descriptions.Item
                            label={
                              <span className="sub-heading">
                                {t("status_date")}
                              </span>
                            }
                          >
                            {ginfo.statusDate}
                          </Descriptions.Item>
                          <Descriptions.Item
                            label={
                              <span className="sub-heading">
                                {t("case_no")}
                              </span>
                            }
                          >
                            {ginfo.caseNumbers}
                          </Descriptions.Item>
                        </>
                      ) : null}
                      <Descriptions.Item
                        label={
                          <span className="sub-heading">{t("view_order")}</span>
                        }
                      >
                        {ginfo.orderFIle ? (
                          <a
                            download
                            href={`https://pcimageupload.s3.ap-south-1.amazonaws.com/${ginfo.orderFIle}`}
                            style={{
                              color: "#1890ff",
                              textDecoration: "underline",
                            }}
                          >
                            {ginfo.orderFIle}
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </Descriptions.Item>

                      {ginfo.date_of_cancellation_of_action ? (
                        <Descriptions.Item
                          label={
                            <span className="sub-heading">
                              {t("cancellation")}
                            </span>
                          }
                        >
                          <Text
                            style={{
                              color: "#ff4d4f",
                              marginTop: "2px",
                              fontSize: "15px",
                            }}
                          >
                            {t("cancel_action")} (
                            {moment(
                              ginfo?.date_of_cancellation_of_action,
                            ).format("DD/MM/YYYY")}
                            )
                          </Text>{" "}
                        </Descriptions.Item>
                      ) : ginfo.status === "completed" ? (
                        <Descriptions.Item
                          label={
                            <span className="sub-heading">
                              {t("cancellation")}
                            </span>
                          }
                        >
                          <Text
                            style={{
                              color: "#faad14",
                              marginTop: "2px",
                              fontSize: "15px",
                            }}
                          >
                            {t("completed")}
                          </Text>
                        </Descriptions.Item>
                      ) : (
                        ginfo.status === "ongoing" && (
                          <Descriptions.Item
                            label={
                              <span className="sub-heading">
                                {t("cancellation")}
                              </span>
                            }
                          >
                            <Text
                              style={{
                                color: "#52c41a",
                                marginTop: "2px",
                                fontSize: "15px",
                              }}
                            >
                              {t("ongoing")}
                            </Text>{" "}
                          </Descriptions.Item>
                        )
                      )}
                    </Descriptions>
                    <Descriptions.Item
                      label={<span className="sub-heading">{t("bond_type")}</span>}
                    >
                      {ginfo.type === "final_bond"
                        ? t("final_bond")
                        : ginfo.type === "interim_bond"
                          ? t("interim_bond")
                          : "-"}
                    </Descriptions.Item>
                  </Card>
                </>
              ))}
          </PageHeader>
        </div>
        <div ref={arrestInfoRef}>
          <PageHeader ghost={false} onBack={false} title={t("arrest_history")}>
            {arrestInfo &&
              arrestInfo
                .filter((ginfo) => ginfo?.arrestInfo.length > 0)
                .map((ginfo, displayIndex) => (
                  <>
                    {ginfo?.arrestInfo.length > 0 && (
                      <>
                        <Divider
                          orientation="left"
                          style={{ margin: "10px 0px" }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <span>
                              {t("arrest1") + " - "}
                              {displayIndex + 1}
                            </span>
                            {ginfo?.arrestInfo?.[0]?.photos &&
                              ginfo?.arrestInfo?.[0]?.photos.length > 0 && (
                                <span style={{ marginLeft: "50px" }}>
                                  {t("photo") + " - "}
                                </span>
                              )}
                            {ginfo?.arrestInfo?.[0]?.photos ? (
                              <>
                                {ginfo?.arrestInfo?.[0]?.photos.map((item) => (
                                  <>
                                    <Card
                                      className="viewCard"
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                        marginLeft: "15px",
                                        borderRadius: "50%",
                                      }}
                                      cover={
                                        // <ImageViewer>
                                        <img
                                          alt="example"
                                          src={`https://pcimageupload.s3.ap-south-1.amazonaws.com/${item}`}
                                          style={{
                                            width: 100,
                                            height: 100,
                                            borderRadius: "50%",
                                          }}
                                          onClick={() =>
                                            openImageModal(
                                              item,
                                              basicInfo && basicInfo[0]?.id,
                                            )
                                          }
                                        />
                                        // </ImageViewer>
                                      }
                                    />
                                  </>
                                ))}
                              </>
                            ) : (
                              // <span style={{ marginLeft: "50px" }}>
                              //   {t("photo") - t("no")}
                              // </span>
                              ""
                            )}
                          </div>
                        </Divider>
                        <Card className="viewCard profile-desc">
                          <Descriptions
                            size="small"
                            column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 3 }}
                          >
                            <Descriptions.Item
                              label={
                                <span className="sub-heading">
                                  {t("current_status")}
                                </span>
                              }
                            >
                              {ginfo && ginfo?.arrestInfo.length > 0
                                ? ginfo?.arrestInfo &&
                                  ginfo?.arrestInfo[0]?.sadyasthiti?.[0]?.title
                                : ""}
                            </Descriptions.Item>
                            <Descriptions.Item
                              label={
                                <span className="sub-heading">
                                  {t("arrest_date_time")}
                                </span>
                              }
                            >
                              {ginfo && ginfo?.arrestInfo.length > 0
                                ? ginfo?.arrestInfo &&
                                  moment(
                                    ginfo?.arrestInfo[0]?.arrest_dateTime,
                                  ).format("DD/MM/YYYY")
                                : ""}
                            </Descriptions.Item>
                            <Descriptions.Item
                              label={
                                <span className="sub-heading">
                                  {t("court_appearance_datetime")}
                                </span>
                              }
                            >
                              {ginfo && ginfo?.arrestInfo.length > 0
                                ? ginfo?.arrestInfo &&
                                  moment(
                                    ginfo?.arrestInfo[0]?.court_dateTime,
                                  ).format("DD/MM/YYYY")
                                : ""}
                            </Descriptions.Item>
                            <Descriptions.Item
                              label={
                                <span className="sub-heading">
                                  {t("aadhaar_number")}
                                </span>
                              }
                            >
                              {ginfo && ginfo?.arrestInfo.length > 0
                                ? ginfo && ginfo?.arrestInfo[0]?.aadharno
                                : ""}
                            </Descriptions.Item>
                            <Descriptions.Item
                              label={
                                <span className="sub-heading">
                                  {t("accused_dob")}
                                </span>
                              }
                            >
                              {ginfo && ginfo?.arrestInfo.length > 0
                                ? ginfo?.arrestInfo &&
                                  ginfo?.arrestInfo[0]?.criminal_dob &&
                                  ginfo.arrestInfo[0].criminal_dob.trim() !==
                                    "" &&
                                  moment(
                                    parseDateAnyFormat(
                                      ginfo.arrestInfo[0].criminal_dob,
                                    ),
                                  ).isValid() &&
                                  moment(
                                    parseDateAnyFormat(
                                      ginfo.arrestInfo[0].criminal_dob,
                                    ),
                                  ).format("DD/MM/YYYY")
                                : ""}
                            </Descriptions.Item>
                            <Descriptions.Item
                              label={
                                <span className="sub-heading">
                                  {t("ambis_fingerprint_taken")}
                                </span>
                              }
                            >
                              <span style={{ wordBreak: "normal" }}>
                                {ginfo && ginfo?.arrestInfo.length > 0
                                  ? ginfo?.arrestInfo &&
                                    ginfo?.arrestInfo[0]?.option_system == "1"
                                    ? t("yes")
                                    : t("no")
                                  : ""}
                              </span>
                            </Descriptions.Item>
                          </Descriptions>
                        </Card>
                      </>
                    )}
                  </>
                ))}
          </PageHeader>
        </div>
        <div ref={noticeInfoRef}>
          <PageHeader ghost={false} onBack={false} title={t("notice")}>
            <Card className="viewCard profile-desc">
              {noticeInfo &&
                noticeInfo
                  .filter((ginfo) => ginfo?.noticeInfo.length > 0)
                  .map((ginfo, displayIndex) => (
                    <>
                      <Divider
                        orientation="left"
                        style={{ margin: "10px 0px" }}
                      >
                        {t("notice") + " - "}
                        {displayIndex + 1}
                      </Divider>
                      <Descriptions>
                        <Descriptions.Item
                          label={
                            <span className="sub-heading">
                              {t("action_taken_police_station")}
                            </span>
                          }
                        >
                          {ginfo?.noticeInfo[0]?.action_taken_police_station}
                        </Descriptions.Item>

                        <Descriptions.Item
                          label={
                            <span className="sub-heading">नोटीस चा प्रकार</span>
                          }
                        >
                          {ginfo?.noticeInfo[0]?.type === "BNS_35_3"
                            ? "भारतीय नागरिक सुरक्षा संहिता २०२३ चे कलम ३५(३) प्रमाणे"
                            : ginfo?.type === "CrPC_41A" &&
                              "फौजदारी प्रक्रिया संहिता ४१(अ) प्रमाणे"}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={
                            <span className="sub-heading">
                              {t("notice_date")}
                            </span>
                          }
                        >
                          {moment(ginfo?.noticeInfo[0]?.notice_date).format(
                            "DD/MM/YYYY",
                          )}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={
                            <span className="sub-heading">
                              {t("officer_name")}
                            </span>
                          }
                        >
                          {ginfo?.noticeInfo[0]?.name}
                        </Descriptions.Item>

                        <Descriptions.Item
                          label={
                            <span className="sub-heading">
                              {t("officer_mobile")}
                            </span>
                          }
                        >
                          {ginfo?.noticeInfo[0]?.mobile_no}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={
                            <span className="sub-heading">
                              आरोपीचा मोबईल नंबर
                            </span>
                          }
                        >
                          {ginfo?.noticeInfo[0]?.aaropi_number}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={
                            <span className="sub-heading">
                              {t("accused_aadhaar_number")}
                            </span>
                          }
                        >
                          {ginfo?.noticeInfo[0]?.aaropi_aadhar_number}
                        </Descriptions.Item>

                        <Descriptions.Item
                          label={
                            <span className="sub-heading">
                              {t("accused_address")}
                            </span>
                          }
                        >
                          {ginfo?.noticeInfo[0]?.aaropi_address}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={
                            <span className="sub-heading">{t("pincode")}</span>
                          }
                        >
                          {ginfo?.noticeInfo[0]?.aaropi_pincode}
                        </Descriptions.Item>
                        {ginfo?.noticeInfo[0]?.photo && (
                          <Descriptions.Item
                            label={
                              <span className="sub-heading">
                                {t("notice_pdf")}
                              </span>
                            }
                          >
                            {ginfo?.noticeInfo[0]?.photo && (
                              <Button
                                type="link"
                                icon={<DownloadOutlined />}
                                style={{ background: "#fff", color: "#1890ff" }}
                                href={
                                  "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                                  ginfo?.noticeInfo[0]?.photo
                                }
                              >
                                Download
                              </Button>
                            )}
                          </Descriptions.Item>
                        )}
                      </Descriptions>
                    </>
                  ))}
            </Card>
          </PageHeader>
        </div>
        <div ref={socialInfoRef}>
          <PageHeader
            ghost={false}
            onBack={false}
            title={t("other_accused_information")}
          >
            {otherInfo && otherInfo.length ? (
              <Card className="viewCard profile-desc">
                <Descriptions
                  size="small"
                  column={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}
                >
                  <Descriptions.Item
                    label={
                      <span className="sub-heading">{t("is_gang_member")}</span>
                    }
                  >
                    {otherInfo &&
                      otherInfo[otherInfo.length - 1].isMemberOfGang}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <span className="sub-heading">
                        {t("accused_occupation_income_source")}
                      </span>
                    }
                  >
                    {otherInfo && otherInfo[otherInfo.length - 1].accusedAssets}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <span className="sub-heading">
                        {t("accused_family_member")}
                      </span>
                    }
                  >
                    {otherInfo &&
                      otherInfo[otherInfo.length - 1].accusedFamilyMember}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <span className="sub-heading">
                        {t("family_members_names")}
                      </span>
                    }
                  >
                    {otherInfo &&
                      otherInfo[otherInfo.length - 1].accusedBusiness}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <span className="sub-heading">
                        {t("accused_location_lat_long")}
                      </span>
                    }
                  >
                    {otherInfo &&
                      otherInfo[otherInfo.length - 1]?.accusedResidence}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <span className="sub-heading">
                        {t("accused_crime_area")}
                      </span>
                    }
                  >
                    {otherInfo &&
                      otherInfo[otherInfo.length - 1]?.accusedJurisdiction}
                  </Descriptions.Item>
                  {/* <Descriptions.Item
                  label={
                    <span className="sub-heading">
                      दाखल गुन्ह्यांचे कोर्ट केस नंबर
                    </span>
                  }
                >
                  <div>{(otherInfo && otherInfo[otherInfo.length - 1].registered_criminal_cases && Array.isArray(otherInfo[otherInfo.length - 1].registered_criminal_cases))
                    ?
                    otherInfo && otherInfo[otherInfo.length - 1].registered_criminal_cases?.map((item) => <li>{item?.case_no}</li>)
                    : ""
                  }</div>
                </Descriptions.Item> */}
                  {/* <Descriptions.Item
                  label={
                    <span className="sub-heading">
                      आरोपीच्या कोर्टातील तारखा
                    </span>
                  }
                >
                  {otherInfo &&
                    moment(otherInfo[otherInfo.length - 1].accusedCourtDate).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )}
                </Descriptions.Item> */}
                  <Descriptions.Item
                    label={
                      <span className="sub-heading">
                        {t("accused_current_status")}
                      </span>
                    }
                  >
                    {otherInfo &&
                      otherInfo[otherInfo.length - 1].accusedjailStatus}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <span className="sub-heading">
                        {t("accused_vehicles_rto_numbers")}
                      </span>
                    }
                  >
                    {otherInfo &&
                      otherInfo[otherInfo.length - 1].accusedVehicalDetails}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <span className="sub-heading">
                        आरोपीच्या वकीलांचे नाव पत्ता व मोबाईल नंबर
                      </span>
                    }
                  >
                    {otherInfo &&
                      otherInfo[otherInfo.length - 1].accusedLawyerDetails}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <span className="sub-heading">
                        {t("officers_identifying_accused")}
                      </span>
                    }
                  >
                    {otherInfo &&
                      otherInfo[otherInfo.length - 1].accusedIdentifyingOfficer}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <span className="sub-heading">
                        {t("supporting_leaders_organizations")}
                      </span>
                    }
                  >
                    {otherInfo &&
                      otherInfo[otherInfo.length - 1].accusedSupportingleaders}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            ) : null}
          </PageHeader>
        </div>
        <div ref={courtInfoRef}>
          <PageHeader
            ghost={false}
            onBack={false}
            title={t("court_cases")}
            subTitle={t("court_cases")}
          >
            {otherInfo &&
            otherInfo[otherInfo.length - 1]?.registered_criminal_cases &&
            Array.isArray(
              otherInfo[otherInfo.length - 1]?.registered_criminal_cases,
            ) &&
            otherInfo[otherInfo.length - 1]?.registered_criminal_cases.length >
              0 ? (
              <Card className="viewCard profile-desc">
                {otherInfo[otherInfo.length - 1]?.registered_criminal_cases.map(
                  (item, index) => (
                    <>
                      {otherInfo[otherInfo.length - 1]
                        ?.registered_criminal_cases.length > 0 && (
                        <>
                          <Divider
                            orientation="left"
                            style={{ margin: "10px 0px" }}
                          >
                            {t("case") + " - "}
                            {index + 1}
                          </Divider>
                          <Card className="viewCard">
                            <Descriptions
                              size="small"
                              column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                            >
                              <Descriptions.Item
                                label={
                                  <span className="sub-heading">
                                    {t("case_no")}
                                  </span>
                                }
                              >
                                {item?.case_no ? item?.case_no : "-"}
                              </Descriptions.Item>
                              <Descriptions.Item
                                label={
                                  <span className="sub-heading">
                                    {t("next_date")}
                                  </span>
                                }
                              >
                                {"-"}
                              </Descriptions.Item>
                              <Descriptions.Item
                                label={
                                  <span className="sub-heading">
                                    {t("details")}
                                  </span>
                                }
                              >
                                {"-"}
                              </Descriptions.Item>
                            </Descriptions>
                          </Card>
                        </>
                      )}
                    </>
                  ),
                )}
              </Card>
            ) : (
              ""
            )}
          </PageHeader>
        </div>
        <div ref={documenInfoRef}>
          <PageHeader
            ghost={false}
            onBack={false}
            title="आरोपीचे ओळखपत्र"
            subTitle="आरोपीचे ओळखपत्र"
          >
            {props.dataStates?.criminalViewList &&
              props.dataStates?.criminalViewList?.document_vehicle && (
                <>
                  <Typography.Text
                    style={{ fontSize: "16px", fontWeight: "600" }}
                  >
                    Vehicle
                  </Typography.Text>
                  <Card className="viewCard profile-desc">
                    <Descriptions
                      size="small"
                      column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                    >
                      <Descriptions.Item label="Rc Number">
                        {props.dataStates?.criminalViewList?.document_vehicle &&
                          props.dataStates?.criminalViewList?.document_vehicle
                            .rc_number}
                      </Descriptions.Item>
                      <Descriptions.Item label="Full Name">
                        {props.dataStates?.criminalViewList?.document_vehicle &&
                          props.dataStates?.criminalViewList?.document_vehicle
                            .owner_name}
                      </Descriptions.Item>
                      <Descriptions.Item label="Insurance Upto">
                        {props.dataStates?.criminalViewList?.document_vehicle &&
                          moment(
                            props.dataStates?.criminalViewList?.document_vehicle
                              .insurance_upto,
                          ).format("DD/MM/YYYY")}
                      </Descriptions.Item>
                      <Descriptions.Item label="Fit Upto Name">
                        {props.dataStates?.criminalViewList?.document_vehicle &&
                          moment(
                            props.dataStates?.criminalViewList?.document_vehicle
                              .fit_up_to,
                          ).format("DD/MM/YYYY")}
                      </Descriptions.Item>
                      <Descriptions.Item label="Make Model">
                        {props.dataStates?.criminalViewList?.document_vehicle &&
                          props.dataStates?.criminalViewList?.document_vehicle
                            .maker_model}
                      </Descriptions.Item>
                    </Descriptions>
                  </Card>
                </>
              )}
            {props.dataStates?.criminalViewList &&
              props.dataStates?.criminalViewList?.document_driving_license && (
                <>
                  <Typography.Text
                    style={{ fontSize: "16px", fontWeight: "600" }}
                  >
                    Driving Licence
                  </Typography.Text>
                  <Card className="viewCard profile-desc">
                    <Descriptions
                      size="small"
                      column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                    >
                      <Descriptions.Item label="Licence Number">
                        {props.dataStates?.criminalViewList
                          ?.document_driving_license &&
                          props.dataStates?.criminalViewList
                            ?.document_driving_license.license_number}
                      </Descriptions.Item>
                      <Descriptions.Item label="Full Name">
                        {props.dataStates?.criminalViewList
                          ?.document_driving_license &&
                          props.dataStates?.criminalViewList
                            ?.document_driving_license.name}
                      </Descriptions.Item>
                      <Descriptions.Item label="DOB">
                        {props.dataStates?.criminalViewList
                          ?.document_driving_license &&
                          moment(
                            props.dataStates?.criminalViewList
                              ?.document_driving_license.dob,
                          ).format("DD/MM/YYYY")}
                      </Descriptions.Item>
                    </Descriptions>
                  </Card>
                </>
              )}
            {props.dataStates?.criminalViewList &&
              props.dataStates?.criminalViewList?.document_adhhar && (
                <>
                  <Typography.Text
                    style={{ fontSize: "16px", fontWeight: "600" }}
                  >
                    Addhar
                  </Typography.Text>
                  <Card className="viewCard profile-desc">
                    <Descriptions
                      size="small"
                      column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                    >
                      <Descriptions.Item label="Aadhar Number">
                        {props.dataStates?.criminalViewList?.document_adhhar &&
                          props.dataStates?.criminalViewList?.document_adhhar
                            .aadhaar_number}
                      </Descriptions.Item>
                      <Descriptions.Item label="Gender">
                        {props.dataStates?.criminalViewList?.document_adhhar &&
                        props.dataStates?.criminalViewList?.document_adhhar
                          .gender == "F"
                          ? "Female"
                          : "Male"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Age Range">
                        {props.dataStates?.criminalViewList?.document_adhhar &&
                          props.dataStates?.criminalViewList?.document_adhhar
                            .age_range}
                      </Descriptions.Item>
                      <Descriptions.Item label="Last 3 digit">
                        {props.dataStates?.criminalViewList?.document_adhhar &&
                          props.dataStates?.criminalViewList?.document_adhhar
                            .last_digits}
                      </Descriptions.Item>
                    </Descriptions>
                  </Card>
                </>
              )}
            {props.dataStates?.criminalViewList &&
              props.dataStates?.criminalViewList?.document_voter && (
                <>
                  <Typography.Text
                    style={{ fontSize: "16px", fontWeight: "600" }}
                  >
                    Voter
                  </Typography.Text>
                  <Card className="viewCard profile-desc">
                    <Descriptions
                      size="small"
                      column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                    >
                      <Descriptions.Item label="Voter Id">
                        {props.dataStates?.criminalViewList?.document_voter &&
                          props.dataStates?.criminalViewList?.document_voter
                            .epic_no}
                      </Descriptions.Item>
                      <Descriptions.Item label="Name">
                        {props.dataStates?.criminalViewList?.document_voter &&
                          props.dataStates?.criminalViewList?.document_voter
                            .name}
                      </Descriptions.Item>
                      <Descriptions.Item label="DOB">
                        {props.dataStates?.criminalViewList?.document_voter &&
                          moment(
                            props.dataStates?.criminalViewList?.document_voter
                              .dob,
                          ).format("DD/MM/YYYY")}
                      </Descriptions.Item>
                      <Descriptions.Item label="Assembly Constituency">
                        {props.dataStates?.criminalViewList?.document_voter &&
                          props.dataStates?.criminalViewList?.document_voter
                            .assembly_constituency}
                      </Descriptions.Item>
                      <Descriptions.Item label="Parliamentary Constituency">
                        {props.dataStates?.criminalViewList?.document_voter &&
                          props.dataStates?.criminalViewList?.document_voter
                            .parliamentary_constituency}
                      </Descriptions.Item>
                    </Descriptions>
                  </Card>
                </>
              )}
            {props.dataStates?.criminalViewList &&
              props.dataStates?.criminalViewList?.document_passport && (
                <>
                  <Typography.Text
                    style={{ fontSize: "16px", fontWeight: "600" }}
                  >
                    Passport
                  </Typography.Text>

                  <Card className="viewCard profile-desc">
                    <Descriptions
                      size="small"
                      column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                    >
                      <Descriptions.Item label="File Number">
                        {props.dataStates?.criminalViewList
                          ?.document_passport &&
                          props.dataStates?.criminalViewList?.document_passport
                            .file_number}
                      </Descriptions.Item>
                      <Descriptions.Item label="Name">
                        {props.dataStates?.criminalViewList
                          ?.document_passport &&
                          props.dataStates?.criminalViewList?.document_passport
                            .full_name}
                      </Descriptions.Item>
                      <Descriptions.Item label="DOB">
                        {props.dataStates?.criminalViewList
                          ?.document_passport &&
                          moment(
                            props.dataStates?.criminalViewList
                              ?.document_passport.dob,
                          ).format("DD/MM/YYYY")}
                      </Descriptions.Item>
                      <Descriptions.Item label="Passport Number">
                        {props.dataStates?.criminalViewList
                          ?.document_passport &&
                          props.dataStates?.criminalViewList?.document_passport
                            .passport_number}
                      </Descriptions.Item>
                      <Descriptions.Item label="Date of Application">
                        {props.dataStates?.criminalViewList
                          ?.document_passport &&
                          moment(
                            props.dataStates?.criminalViewList
                              ?.document_passport.date_of_application,
                          ).format("DD/MM/YYYY")}
                      </Descriptions.Item>
                    </Descriptions>
                  </Card>
                </>
              )}
          </PageHeader>
        </div>
        <PageHeader
          ghost={false}
          onBack={false}
          title={t("fingerprints_and_professional_details")}
        >
          <Card className="viewCard profile-desc">
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
            >
              <Descriptions.Item>
                {otherInfo && otherInfo.length
                  ? otherInfo[otherInfo.length - 1].accusedPham &&
                    otherInfo[otherInfo.length - 1].accusedPham.length &&
                    otherInfo[otherInfo.length - 1].accusedPham
                      .split(",")
                      .map((item) => (
                        <Card
                          hoverable
                          style={{ width: 100 }}
                          cover={
                            <img
                              alt="example"
                              src={
                                "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                                item
                              }
                              onClick={() =>
                                openImageModal(
                                  item,
                                  basicInfo && basicInfo[0]?.id,
                                )
                              }
                            />
                          }
                        ></Card>
                      ))
                  : null}
              </Descriptions.Item>
              <Descriptions.Item>
                {otherInfo && otherInfo.length
                  ? otherInfo[otherInfo.length - 1].accusedRecords &&
                    otherInfo[otherInfo.length - 1].accusedRecords.length &&
                    otherInfo[otherInfo.length - 1].accusedRecords
                      .split(",")
                      .map((item) => (
                        <a
                          href={
                            "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                            item
                          }
                        >
                          {item}
                        </a>
                      ))
                  : null}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </PageHeader>
        <div style={{ position: "fixed", bottom: "15%", right: "15%" }}>
          <Button
            type="primary"
            icon={<UpOutlined />}
            id="scroll-up"
            onClick={() => scrollToTop()}
          ></Button>
        </div>
        {imageOpen && (
          <ImageViewOnly
            imageOpen={imageOpen}
            imageUrl={
              "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
              selectedImage
            }
            onClose={closeImageModal}
            id={id}
          />
        )}
      </div>
    </>
  );
};

const connectedAaropiShodha = connect()(ViewFormModel);
export { connectedAaropiShodha as ViewFormModel };
